define([
    'text!index2021-aboutservice/component/page-content.html',
    'common/api',
    'jquery',
    'WebCommon/utils',
    'WebCommon/component/image-link-slick',

    'css!index2021-aboutservice/component/page-content.css'
], function(
    tpl,Api,$,Utils,
    ImageLinkSlick
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                activeIndex:0,
                service: {}
            };
        },
        components: {
        },
        computed: {

        },
        created: function () {
            var obj = this;


        },
        methods: {
            changeIndex:function (index)
            {
                this.activeIndex = index;
            },
            init: function () {
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    obj.isPC = true;
                }
                Api.getService.ajax({})
                    .done(function (data) {
                        obj.service = data;
                        Utils.emitPageReady();
                    });
            },

        },
        mounted: function(){
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                obj.getHeight();
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-aboutservice/component/page-content.js
// module id = 182
// module chunks = 12